import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { Wrapper } from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter/Styles/style'

const JDFilter = ({ jdValue, setJDValue }) => {
  const tierOptions = [
    {
      label: 'Accepted',
      value: '1',
    },
    {
      label: 'Pending',
      value: '0',
    },
    {
      label: 'Rejected',
      value: '-1',
    },
  ]
  return (
    <Wrapper column>
      <FilterCheckBoxComp
        value={jdValue}
        options={tierOptions}
        onChange={values => setJDValue([values[values?.length - 1]])}
      />
    </Wrapper>
  )
}

export default JDFilter
